import { BillerSelectOption } from 'pages/Transfer/BPay/AddBpayDetailsModal/components/BillerCodeSearchInput/BillerCodeSearchInput.utils'

export const defaultSelectedOption: BillerSelectOption = {
  id: '',
  value: '',
  label: '',
  subLabel: '',
  icon: 'biller',
}
